import React, { createContext } from 'react';

const FeedbackContext = createContext(null);

export default FeedbackContext;
